import { render, staticRenderFns } from "./default-disclaimer-table.vue?vue&type=template&id=6a27753b"
import script from "./default-disclaimer-table.vue?vue&type=script&lang=js"
export * from "./default-disclaimer-table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports